module.exports = __webpack_public_path__ + "img/nadokenske_rolete.fe718d1b.svg";